<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <div class="footer-logo">
            <img src="/images/z3c.png" alt="Z3C Logo" class="footer-logo-img" />
            <div class="footer-brand-text">
              <h3>Z3C</h3>
              <p>Soluções Profissionais em Tecnologia</p>
            </div>
          </div>
          <p class="footer-description">
            {{ $t('footer.description') }}
          </p>
        </div>
        
        <div class="footer-info">
          <div class="footer-section">
            <h4>{{ $t('footer.contact') }}</h4>
            <div class="contact-item">
              <span class="contact-label">{{ $t('footer.email') }}</span>
              <a href="mailto:contato@z3c.com.br">contato@z3c.com.br</a>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t('footer.phone') }}</span>
              <a href="tel:+5551993402833">(51) 99340-2833</a>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t('footer.schedule') }}</span>
              <span>{{ $t('footer.scheduleText') }}</span>
            </div>
          </div>
          
          <div class="footer-section">
            <h4>{{ $t('footer.specialties') }}</h4>
            <ul>
              <li>{{ $t('footer.development') }}</li>
              <li>{{ $t('footer.consulting') }}</li>
              <li>{{ $t('footer.ai') }}</li>
              <li>{{ $t('footer.automation') }}</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="footer-legal">
          <p>&copy; {{ currentYear }} {{ $t('footer.copyright') }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer {
  background: var(--background-accent);
  border-top: 1px solid var(--border-medium);
  padding: var(--space-16) 0 var(--space-8);
  position: relative;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--gradient-primary);
}

.footer-content {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: var(--space-16);
  margin-bottom: var(--space-12);
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: var(--space-4);
}

.footer-logo-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

.footer-brand-text h3 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-light);
  margin: 0 0 var(--space-1) 0;
  line-height: var(--line-height-tight);
}

.footer-brand-text p {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-weight: var(--font-weight-normal);
}

.footer-description {
  color: rgba(255, 255, 255, 0.8);
  line-height: var(--line-height-relaxed);
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-base);
}



.footer-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.footer-section h4 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-light);
  margin-bottom: 1rem;
}

.contact-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.contact-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.contact-item span:last-child,
.contact-item a {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-decoration: none;
}

.contact-item a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.footer-section ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-section ul li {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  font-weight: 400;
}

.footer-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-legal p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
  text-align: center;
  margin: 0;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: var(--space-8);
  }
  
  .footer-logo {
    flex-direction: column;
    text-align: center;
    gap: var(--space-4);
  }
  
  .footer-info {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
  
  .footer-logo-img {
    width: 60px;
    height: 60px;
  }
}
</style>
